export default __webpack_public_path__ + "static/media/pulse_progress.3c05876f.svg";